import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-17" data-mp="3og1dgq24i0ap">
      <div className="mx-auto w-full max-w-5xl" data-id="element-18" data-mp="3ofhxvfzy3nzu">
        <Reveal data-id="element-19" data-mp="3sgtlxh36815x">
          <div className="overflow-hidden rounded-3xl border border-sand" data-id="element-20" data-mp="3sgbls9de12sq">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-21" data-mp="3epg5ic0k7jf4">
              <div className="border-b border-sand bg-cream px-7 py-9 md:border-b-0 md:border-r sm:px-9" data-id="element-22" data-mp="3envf8yla2mn2">
                <p className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-level-red" data-id="element-23" data-mp="3jihrt533il8q">
                  Kostnaden av att börja från noll
                </p>
                <h3 className="mt-3 font-serif text-4xl leading-none text-navy/70" data-id="element-24" data-mp="39r4x85pwxgz0">
                  FÖRE
                </h3>

                <ul className="mt-7 space-y-4" data-id="element-25" data-mp="30q73cg96upu5">
                  {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-26" data-mp="30s02zbldw9sn">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-level-red/10" data-id="element-27" data-mp="x2qv5fhtb3w6">
                        <XIcon className="h-3.5 w-3.5 text-level-red" aria-hidden="true" data-id="element-28" data-mp="172q3bbabks8i" />
                      </span>
                      <span className="text-sm leading-relaxed text-muted" data-id="element-29" data-mp="121u2x7p6fo7u">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-white px-7 py-9 sm:px-9" data-id="element-30" data-mp="9gsrfwqg3l5j">
                <p className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-level-green" data-id="element-31" data-mp="o45g3ubju705">
                  Systemet som är redo att använda
                </p>
                <h3 className="mt-3 font-serif text-4xl leading-none text-navy" data-id="element-32" data-mp="3rsyzb2sumye6">
                  MED INNEBANDY READY
                </h3>

                <ul className="mt-7 space-y-4" data-id="element-33" data-mp="3msufb2sqflj7">
                  {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-34" data-mp="1qpogm83dsxml">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-level-green/12" data-id="element-35" data-mp="1vpar49rtrzrp">
                        <CheckIcon className="h-3.5 w-3.5 text-level-green" aria-hidden="true" data-id="element-36" data-mp="20hu3x4iouqvg" />
                      </span>
                      <span className="text-sm font-semibold leading-relaxed text-navy" data-id="element-37" data-mp="17t6ovqoj8xqc">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>

            <p className="border-t border-sand bg-navy px-7 py-6 text-center text-sm font-semibold leading-relaxed text-cream sm:px-9 sm:text-base" data-id="element-38" data-mp="1lrmx5m21mwal">
              En komplett innebandyläroplan som hjälper dig förbereda mindre och undervisa
              med mer trygghet.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}